/* Contact form — prefill inquiry type + product from URL query params.
   Slab/porcelain CTAs link to /pages/contact?product=<handle>&inquiry=<type>. */
(function () {
  'use strict';
  var params = new URLSearchParams(window.location.search);
  var product = params.get('product');
  var inquiry = params.get('inquiry');

  var select = document.querySelector('[data-inquiry-select]');
  if (select && inquiry) {
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === inquiry) { select.selectedIndex = i; break; }
    }
  }

  if (product) {
    var wrap = document.querySelector('[data-contact-product]');
    var nameEl = document.querySelector('[data-contact-product-name]');
    var input = document.querySelector('[data-contact-product-input]');
    var pretty = product.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    if (wrap) wrap.hidden = false;
    if (nameEl) nameEl.textContent = pretty;
    if (input) input.value = product;
  }
})();
